import { Duplicate } from './duplicate';
import { z } from 'zod';

export const Hash = z.object({
    algorithm: z.string(),
    hash: z.string(),
});

export const ReceiptFileBase = z.object({
    id: z.string(),
    contentType: z.string(),
    size: z.number(),
    hash: Hash.nullish().catch(undefined),
});
export type ReceiptFileBase = z.infer<typeof ReceiptFileBase>;

export const ReceiptFile = ReceiptFileBase.extend({
    width: z.number().nullish(),
    height: z.number().nullish(),
    etag: z.string().nullish(),
    uploadHash: Hash.nullish().catch(undefined),
    original: ReceiptFileBase.nullish(),
    rotation: z.number().nullish(),
    duplicates: z.array(Duplicate).nullish(),
});
export type ReceiptFile = z.infer<typeof ReceiptFile>;
